import { render, staticRenderFns } from "./DiscountCalculator.vue?vue&type=template&id=495b88f6&"
import script from "./DiscountCalculator.vue?vue&type=script&lang=js&"
export * from "./DiscountCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports